import { render, staticRenderFns } from "./contact_form.vue?vue&type=template&id=3bca8903&scoped=true&"
import script from "./contact_form.vue?vue&type=script&lang=js&"
export * from "./contact_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca8903",
  null
  
)

export default component.exports